import baseUrl from '@/assets/js/baseUrl.js';
import http from './http'

export var login = {
	// 登录
	login(params) {
	    return http.post(`${baseUrl}Login/companyUserLogin`, params)
	},
	// 发送验证码
	sendCode(params) {
	    return http.post(`${baseUrl}Login/sendWxMsg`, params)
	},
	// 微信登录
	weChatLogin(params) {
	    return http.post(`${baseUrl}Login/weChatLogin`, params)
	},
	// 注册
	register(params) {
	    return http.post(`${baseUrl}Login/register`, params)
	},
	// 忘记密码
	checkUserByPhone(params) {
	    return http.post(`${baseUrl}Login/resetPassword`, params)
	},
	// 获取手机号
	getPhone(params) {
	    return http.post(`${baseUrl}StaticConf/telephone`, params)
	},
	// 退出登录
	signOut(params) {
	    return http.post(`${baseUrl}Login/signOut`, params)
	},

  // 酒店加入
  addRegistration(params) {
      return http.post(`${baseUrl}Registration/addRegistration`, params)
  },

}



// WEBPACK FOOTER //
// ./src/api/login.js